export * from "./warning-icon.component";
